import { HOURS_IN_ONE_DAY, ONE_HOUR_IN_SECONDS } from "@src/utils/formatters";

export const validateTime = (val: string): boolean => {
  if (val === "") return false;
  return /^\d*[:,.]?([0-5]\d?|[6-9]?|60)$/.test(val);
};

export const lte24 = (val: number): boolean => {
  return val / ONE_HOUR_IN_SECONDS <= HOURS_IN_ONE_DAY;
};

/**
 * 1 - 01:00
 * 12 - 12:00
 * 123 - 01:23
 * 1234 - 12:34
 * 12345 - 12:34
 * 1261 - 12:59
 */
export const toFullTimeFormat = (val: string) => {
  if (val.length === 1) return [`0${val}`, "00"];
  if (val.length === 2) return [val, "00"];
  if (val.length === 3) {
    const minutes = val.slice(1, 3);
    const minutesNumber = Number(val.slice(1, 3));
    return [val.slice(0, 1), minutesNumber > 59 ? "59" : minutes];
  }
  const minutes = val.slice(2, 4);
  const minutesNumber = Number(val.slice(2, 4));
  return [val.slice(0, 2), minutesNumber > 59 ? "59" : minutes];
};

export const timeToNumber = (
  val: string,
  options?: { mode24?: boolean },
): number => {
  let seconds = 0;
  const [h, m] = val.match(/[:,.]/)
    ? val.split(/[:,.]/)
    : toFullTimeFormat(val);
  if (h) {
    let convertedHours = h.slice(0, 2);
    if (
      options?.mode24 &&
      Number(convertedHours.toString().charAt(0)) !== 2 &&
      Number(convertedHours.toString().charAt(0)) !== 1 &&
      Number(convertedHours.toString().charAt(0)) !== 0
    ) {
      convertedHours = h.slice(0, 1);
    }
    seconds = +convertedHours * ONE_HOUR_IN_SECONDS;
  }
  if (m) {
    seconds += +m.slice(0, 2) * 60;
  }
  return seconds;
};
